import type ApiFactory from '@library/services/api-factory'
import BfAuthApi from './bf-auth-api'
import BfUnAuthApi from './bf-un-auth-api'

export type BfApi = ReturnType<typeof initBfApi>

export const initBfApi = (option: {
  authApi: ApiFactory
  unAuthApi: ApiFactory
}) => {
  const { authApi, unAuthApi } = option

  return {
    bf: {
      /**
       * API - 需登入
       */
      auth: new BfAuthApi(authApi),
      /**
       * API - 不需登入
       */
      unAuth: new BfUnAuthApi(unAuthApi)
    }
  }
}
